import {
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
  } from "@material-tailwind/react";
   
  export default function HomeInsTabs() {
    const data = [
      {
        label: "Section A:",
        value: "Section A",
        desc: `BUILDING:It covers residential buildings including landlords fixtures, fittings, perimeter wall, gate and fences, all on the same premises against fire, natural causes e.g. earthquake, storm and lightning, human causes e.g. riot, strike and malicious damage, explosion e.g. explosion of domestic gas cylinders etc, miscellaneous causes e.g. bursting and overflowing of water tanks, apparatus, pipes and impact by road vehicles and animals.`,
      },
      {
        label: "Section B:",
        value: "Section B:",
        desc: `CONTENTS:This section covers the home owners contents including furniture, household goods and personal effects of every description, the property of the insured or that of any member of his family normally, residing with him, fixtures and fittings of the insured’s or for which he is legally responsible. The property is covered against fire, theft following forcible entry or exit, natural causes e.g. earthquake, storm and lightning etc., human causes e.g. riot, strike and malicious damage, explosion e.g. explosion of domestic gas cylinders etc, miscellaneous causes e.g. bursting and overflowing of water tanks, apparatus, pipes and impact by road vehicles and animals.`,
      },
      {
        label: "Section C:",
        value: "Section C:",
        desc: `ALL RISKS:This covers accidental damage and theft to specified portable items which are carried outside the house such as jewellery, electronic items like mobile phones, laptops, tablets and cameras. etc`,
      },
      {
        label: "Section D:",
        value: "Section D:",
        desc: `WIBA : This covers domestic servants such as house helps, watchmen, gardeners and drivers in respect of injury, death or disease arising out of and in the course of employment. The cover is mandatory for all employers as per the Work Injury Benefit Act (WIBA).`,
      },
      {
        label: "Section E:",
        value: "Section E:",
        desc: `EMPLOYER'S LIABILITY : This policy will indemnify the insured against any such liability incurred thereby under the Employer’s Liability Common Law Tort, which indemnity shall be limited to settlement of such awards except exemplary and punitive damages as my be awarded in judgments passed by competent courts in Kenya against the insured for such liability. Limit Kshs. 500,000/-`,
      },
      {
        label: "Section F:",
        value: "Section F:",
        desc: `OWNER'S LIABILITY: This section covers the home owner against legal liability of third parties for accidental bodily injury and accidental loss of or damage to property.`,
      },
      {
        label: "Section G:",
        value: "Section G:",
        desc: `OCCUPIER'S LIABILITY : This section covers the home occupier against legal liability of third parties for accidental bodily injury and accidental loss of or damage to property.`,
      },
    ];
   
    return (
      <Tabs value="Section A">
        <TabsHeader>
          {data.map(({ label, value }) => (
            <Tab key={value} value={value}>
              {label}
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody>
          {data.map(({ value, desc }) => (
            <TabPanel key={value} value={value}>
              {desc}
            </TabPanel>
          ))}
        </TabsBody>
      </Tabs>
    );
  }